import {
    DESTROY_VALIDATION_ERRORS,
    SET_ERROR_STATUS_CODE,
    SET_VALIDATION_ERRORS
} from "@/core/store/modules/errors/constants";

export default {
    [SET_VALIDATION_ERRORS](state, {errors, form}) {
        if (form) {

            Object.keys(errors).map((error) => {
                if (error.match(/^[a-zA-Z]+.\d+$/g)) {
                    errors[(new RegExp(/(^[a-zA-Z]+).\d+$/g)).exec(error)[1]] = errors[error]
                    delete errors[error]
                }
            })
            form.setErrors(errors);
        }
        state.validationErrors = errors
    },
    [DESTROY_VALIDATION_ERRORS](state, key = null) {
        if (key) {
            delete state.validationErrors[key];
        } else {
            state.validationErrors = {}
        }
    },
    [SET_ERROR_STATUS_CODE](state, status) {
        state.status = status
    }
}